import React, { useState, useEffect } from "react"
import * as classNames from "./GenericReviewSection.module.scss"
import Card from "../../blocks/card/Card"
import Section from "../../../../core/layout/main/section/Section"
import Icon from "../../blocks/icon/Icon"
import Button from "../../blocks/button/Button"
import { Swiper, SwiperSlide } from "swiper/react"
import Image from "../../blocks/image/Image"
import ReviewDialog from "../../blocks/reviewDialog/ReviewDialog"
import "swiper/css"
import "swiper/css/autoplay"
const GenericReviewSection = ({
  showLogo,
  title,
  reviews,
  sectionName,
  logo
}) => {
  const [selectedReview, setSelectedReview] = useState(null)
  const [selectedReviewIndex, setSelectedReviewIndex] = useState(null)

  let dynamicSectionName

  switch (sectionName) {
    case "RhGlassdoorReviewSection":
      dynamicSectionName = "Avis Glassdoor"
      break
    case "ComTrustpilotReviewSection":
      dynamicSectionName = "Avis Trustpilot"
      break

    default:
      dynamicSectionName = "Avis"
  }

  const openDialog = (review, index) => {
    setSelectedReview(review)
    setSelectedReviewIndex(index)
  }

  useEffect(() => {
    if (
      selectedReviewIndex &&
      selectedReviewIndex < reviews.length &&
      selectedReviewIndex >= 0
    ) {
      setSelectedReview(reviews[selectedReviewIndex])
    }
  }, [selectedReviewIndex])

  useEffect(() => {
    if (selectedReview) {
      const dialog = document.querySelector("dialog")
      dialog.showModal()
    }
  }, [selectedReview])

  function generateStars(numStars) {
    const starElements = []
    for (let i = 0; i < numStars; i++) {
      starElements.push(
        <Icon
          key={i}
          icon="star"
          color="#F6B34F"
        />
      )
    }
    return starElements
  }

  return (
    <Section
      className={`pbl-6 pin-4 ${classNames.rhglassdoorreview}`}
      container="xlarge"
    >
      <div className={`text-center mb-4 loadin ${classNames.headerSection}`}>
        <h2>{title}</h2>
        {showLogo && (
          <Image
            dataSizesPreset="none"
            className={classNames.logoGlassDoor}
            imgSrc={logo?.data?.attributes.url}
            imgAlt={logo?.data?.attributes.alternativeText}
            formats={logo?.data?.attributes.formats}
            imgWidth={logo?.data?.attributes.width}
           imgHeight={logo?.data?.attributes.height}
          />
        )}
      </div>
      <Swiper
        type="annonce"
        spaceBetween={48}
        slidesPerView={"auto"}
        wrapperClass="bottom pt-3 pb-6 "
        breakpoints={{
          0: {
            slidesPerView: 1,
            spaceBetween: 46,
          },

          768: {
            slidesPerView: 3,
            spaceBetween: 32,
          },
          1024: {
            slidesPerView: 2.9,
            spaceBetween: 32,
          },
        }}
      >
        {reviews?.length > 0 &&
          reviews?.map((review, index) => (
            <SwiperSlide
              key={index}
            >
              <Card
                type="avis"
                className={`flex flex-direction-column pbl-4 pin-4 ${classNames.cardStyles}`}
              >
                <div className="card__header">
                  <div className="card__header__title mb-1 text-center">
                    {generateStars(review.attributes.stars)}
                    <br />
                    {/* <span
                      className={`fs-20 text-center ${classNames.dateStyle}`}
                    >
                      {countDaysFromDate(
                        review?.attributes?.trustpilotCreatedAt
                          ? review?.attributes?.trustpilotCreatedAt
                          : review?.attributes?.createdAt
                      )}
                    </span>
                    <br /> */}
                    <h5>
                      {" "}
                      <b>{review.attributes.title}</b>
                    </h5>
                  </div>
                </div>
                <div className="card__content mt-md-1">
                  <p className="text-center line-clamp-3">
                    {review.attributes.text.substring(0, 100)} ...
                  </p>
                </div>
                <div
                  className={`card__footer mt-auto ${classNames.cardFooter}`}
                >
                  <Button
                    aspect="unstyled"
                    color="unstyled"
                    onClick={() => openDialog(review, index)}
                    style={{ color: "rgba(0, 0, 0, 0.50)" }}
                  >
                    Lire la suite
                  </Button>
                </div>
              </Card>
            </SwiperSlide>
          ))}
      </Swiper>
      <ReviewDialog
        selectedReview={selectedReview}
        selectedReviewIndex={selectedReviewIndex}
        setSelectedReviewIndex={setSelectedReviewIndex}
        title={dynamicSectionName}
      />
    </Section>
  )
}

export default GenericReviewSection
